import {
  ARTIST_EXPLORE_URL_SEGMENT,
  ARTIST_PAGES_BASE_PATH,
  ARTIST_SHOP_URL_SEGMENT,
} from '@app/data/clients/rbServerSideClient/utils/constants';
import { Box } from '@redbubble/design-system';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { UserInfo } from '@redbubble/next/types';
import { URL_SEGMENT_LOCALES } from '@redbubble/next-i18n';
import { useUserInfo } from '@redbubble/next-provider';
import { useRouter } from 'next/router';
import React from 'react';
import TabList, { Tab } from './Tabs';

const messages = defineMessages({
  shopProducts: {
    defaultMessage: 'Shop Products',
  },
  exploreDesigns: {
    defaultMessage: 'Explore Designs',
  },
});

export const ArtistShopNavTabs = () => {
  const [{ locale }] = useUserInfo<UserInfo>();
  const router = useRouter();
  const intl = useIntl();
  const username = router.query.artistUsername;
  const currentPath = `${URL_SEGMENT_LOCALES[locale]}${router.asPath.split('?')[0]}`;

  const basePath = `${URL_SEGMENT_LOCALES[locale]}${ARTIST_PAGES_BASE_PATH}/${username}`;
  const shopPath = `${basePath}/${ARTIST_SHOP_URL_SEGMENT}`;
  const explorePath = `${basePath}/${ARTIST_EXPLORE_URL_SEGMENT}`;

  return (
    <Box>
      <TabList>
        <Tab href={shopPath} active={currentPath === shopPath}>
          {intl.formatMessage(messages.shopProducts)}
        </Tab>
        <Tab href={explorePath} active={currentPath === explorePath}>
          {intl.formatMessage(messages.exploreDesigns)}
        </Tab>
      </TabList>
    </Box>
  );
};
